import type { Money } from 'shared/util/money';
import type { ObjectImage, ObjectLocation } from '@/domain';
import styles from '@/scenes/createRentalRequestPage/createRentalRequestPage.module.css';
import { PriceOverview } from '@/scenes/objectPage/containers/priceOverview/PriceOverview';
import { formatBookingDateNumeric, formatDateTime } from '@/utils/formatting';

interface Props {
    itemId: number;
    image: ObjectImage | undefined;
    startDate: Date;
    endDate: Date;
    numberOfGuests: string | string[] | undefined;
    location: ObjectLocation;
    setPrice?: (priceTotal: Money) => void;
}

export const RentalRequestItemOverview = ({ image, startDate, endDate, numberOfGuests, itemId, location, setPrice }: Props) => {
    const imageSrc = image?.src ?? '';

    return (
        <article className="flex flex-col gap-16 s-bg-subtle rounded-8 p-16">
            <img className="h-128 rounded-8 w-96 sm:w-auto object-cover" alt="Hovedbilde fra annonsen" src={imageSrc} />
            <div className="flex flex-col gap-8">
                <h3 className="text-14">Din forespørsel</h3>
                <div className="grid grid-cols-3 gap-16 text-14 mb-0">
                    <div className="col-span-1 m-0 text-left">Leieperiode</div>
                    <p className="col-span-2 m-0 gap-4 mb-0 text-right">
                        <time dateTime={formatDateTime(startDate)}>{formatBookingDateNumeric(startDate)}</time>
                        <span className="px-4">-</span>
                        <time dateTime={formatDateTime(endDate)}>{formatBookingDateNumeric(endDate)}</time>
                    </p>
                </div>
                <div className="grid grid-cols-2 gap-16  text-14 mb-0">
                    <div className="col-span-1 text-left">Antall reisende</div>
                    <p className="col-span-1 text-14 text-right mb-0">
                        <span className="pl-8">{numberOfGuests} reisende</span>
                    </p>
                </div>
            </div>
            <PriceOverview
                className={`${styles.priceOverview}`}
                adId={itemId}
                location={location}
                startDate={startDate}
                endDate={endDate}
                numberOfGuests={Number(numberOfGuests)}
                setPrice={setPrice}
            />
        </article>
    );
};
